"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var config_provider_1 = require("../config-provider");
var Checkbox_1 = tslib_1.__importDefault(require("./Checkbox"));
var context_1 = require("./context");
var CheckboxGroup = function (_a) {
    var _b;
    var defaultValue = _a.defaultValue, children = _a.children, _c = _a.options, options = _c === void 0 ? [] : _c, customizePrefixCls = _a.prefixCls, className = _a.className, style = _a.style, onChange = _a.onChange, restProps = tslib_1.__rest(_a, ["defaultValue", "children", "options", "prefixCls", "className", "style", "onChange"]);
    var _d = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _d.getPrefixCls, direction = _d.direction;
    var _e = tslib_1.__read(React.useState(restProps.value || defaultValue || []), 2), value = _e[0], setValue = _e[1];
    var _f = tslib_1.__read(React.useState([]), 2), registeredValues = _f[0], setRegisteredValues = _f[1];
    React.useEffect(function () {
        if ('value' in restProps) {
            setValue(restProps.value || []);
        }
    }, [restProps.value]);
    var getOptions = function () {
        return options.map(function (option) {
            if (typeof option === 'string') {
                return {
                    label: option,
                    value: option,
                };
            }
            return option;
        });
    };
    var cancelValue = function (val) {
        setRegisteredValues(function (prevValues) { return prevValues.filter(function (v) { return v !== val; }); });
    };
    var registerValue = function (val) {
        setRegisteredValues(function (prevValues) { return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(prevValues), false), [val], false); });
    };
    var toggleOption = function (option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = tslib_1.__spreadArray([], tslib_1.__read(value), false);
        if (optionIndex === -1) {
            newValue.push(option.value);
        }
        else {
            newValue.splice(optionIndex, 1);
        }
        if (!('value' in restProps)) {
            setValue(newValue);
        }
        if (onChange) {
            var opts_1 = getOptions();
            onChange(newValue
                .filter(function (val) { return registeredValues.indexOf(val) !== -1; })
                .sort(function (a, b) {
                var indexA = opts_1.findIndex(function (opt) { return opt.value === a; });
                var indexB = opts_1.findIndex(function (opt) { return opt.value === b; });
                return indexA - indexB;
            }));
        }
    };
    var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0, omit_1.default)(restProps, ['value', 'disabled']);
    if (options && options.length > 0) {
        children = getOptions().map(function (option) { return (React.createElement(Checkbox_1.default, { prefixCls: prefixCls, key: option.value.toString(), disabled: 'disabled' in option ? option.disabled : restProps.disabled, value: option.value, checked: value.indexOf(option.value) !== -1, onChange: option.onChange, className: "".concat(groupPrefixCls, "-item"), style: option.style }, option.label)); });
    }
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue,
    };
    var classString = (0, classnames_1.default)(groupPrefixCls, (_b = {},
        _b["".concat(groupPrefixCls, "-rtl")] = direction === 'rtl',
        _b), className);
    return (React.createElement("div", tslib_1.__assign({ className: classString, style: style }, domProps),
        React.createElement(context_1.GroupContext.Provider, { value: context }, children)));
};
exports.default = React.memo(CheckboxGroup);
//# sourceMappingURL=Group.js.map